import { mergeAttributes, Node } from '@tiptap/core';

// Treated as part of the text rather than as a separate block, so images behave
// the way writers expect: pressing Enter splits the paragraph around one,
// Backspace joins it back, and text can sit alongside it on the same line.
export const Image = Node.create({
  name: 'image',
  group: 'inline',
  inline: true,
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: '' },
      title: { default: null },
      width: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const value = element.getAttribute('width');
          if (!value) return null;
          const parsed = Number.parseInt(value, 10);
          return Number.isFinite(parsed) ? parsed : null;
        },
        renderHTML: (attributes: { width?: number | null }) =>
          typeof attributes.width === 'number' && Number.isFinite(attributes.width)
            ? { width: attributes.width }
            : {},
      },
      height: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const value = element.getAttribute('height');
          if (!value) return null;
          const parsed = Number.parseInt(value, 10);
          return Number.isFinite(parsed) ? parsed : null;
        },
        renderHTML: (attributes: { height?: number | null }) =>
          typeof attributes.height === 'number' && Number.isFinite(attributes.height)
            ? { height: attributes.height }
            : {},
      },
      loading: { default: 'lazy' },
    };
  },

  parseHTML() {
    return [{ tag: 'img[src]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['img', mergeAttributes(HTMLAttributes)];
  },
});
